import React from 'react';
import { LoadingIcon } from '../Icon/index.js';
export function LoadingPage() {
    return (React.createElement("div", { className: "twds-h-screen twds-flex twds-items-center twds-justify-center" },
        React.createElement(LoadingIcon, { size: "5xl" })));
}
//# sourceMappingURL=LoadingPage.js.map